export default function () {
  return {
    marketOfferList: [],
    marketUserBidList: [],
    isMarketOpen: false,
    marketMessages: [],
    marketUserBidListLoaded: true,
    marketOfferListLoaded: false,
    marketOfferListLoading: false,
  };
}
